import {changeFormat} from "@/components/tacho/common/CommonFunc";
import dayjs from "dayjs";
import {allCarDriverOpt} from "@/store";

export const dateSelectTypes = {
    dateRange: 'dateRange',
    dateRangeWithMonthSwitch: 'dateRangeWithMonthSwitch',
    dateSingle: 'dateSingle',
};

function convertToTripMapper(props, searchBar, useLimitDate = false) {
    const params = {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        officeId: searchBar.selectedOffice.id,
        carNum: searchBar.selectedCarNum.id,
        driverId: searchBar.selectedCarDriver === allCarDriverOpt ? null : searchBar.selectedCarDriver,
        payType: searchBar.selectedPayType,
    };

    if (useLimitDate) {
        params.fromDtti = changeFormat(searchBar.selectedLimitDate.startIso, 'YYYYMMDDHHmmss');
        params.untilDtti = changeFormat(searchBar.selectedLimitDate.endIso, 'YYYYMMDDHHmmss');
    }

    return params;
}

function convertToDriverShiftMapper(props, searchBar) {
    return {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        officeId: searchBar.selectedOffice.id,
        carNum: searchBar.selectedCarNum.id,
        driverId: searchBar.selectedCarDriver === allCarDriverOpt ? null : searchBar.selectedCarDriver,
        status: 'CLOSE',
    };
}

function convertToOfficeShiftMapper(props, searchBar) {
    return {
        fromDtti: changeFormat(searchBar.selectedStartIso, 'YYYYMMDDHHmmss'),
        untilDtti: changeFormat(searchBar.selectedEndIso, 'YYYYMMDDHHmmss'),
        officeId: searchBar.selectedOffice.id,
        carNum: searchBar.selectedCarNum.id,
        driverId: searchBar.selectedCarDriver === allCarDriverOpt ? null : searchBar.selectedCarDriver,
        groupBy: searchBar.selectByMonth ? 'driver' : null,
    };
}

export function processSubmits(props, searchBar) {
    if (!searchBar.selectedOffice || !searchBar.selectedCarNum) {
        return;
    }

    if (props.onSubmitTripQuery) {
        const params = convertToTripMapper(props, searchBar);
        props.onSubmitTripQuery(params);
    }

    if (props.onSubmitTripQueryLimited) {
        const params = convertToTripMapper(props, searchBar, true);
        props.onSubmitTripQueryLimited(params);
    }

    if (props.onSubmitDriverShiftQuery) {
        const params = convertToDriverShiftMapper(props, searchBar);
        props.onSubmitDriverShiftQuery(params);
    }

    if (props.onSubmitOfficeShiftQuery) {
        const params = convertToOfficeShiftMapper(props, searchBar);
        props.onSubmitOfficeShiftQuery(params);
    }
}

export function getOfficeShiftStartHours(office) {
    const validHours = [0];
    if (office.shiftStartHour > 0) {
        validHours.push(office.shiftStartHour);
    }
    return validHours;
}

export function isIsoValidForOffice(dateIso, office) {
    const validHours = getOfficeShiftStartHours(office);
    const dateJS = dayjs(dateIso);
    return validHours.indexOf(dateJS.hour()) !== -1;
}

export default {
    dateSelectTypes,
    processSubmits,
    getOfficeShiftStartHours,
    isIsoValidForOffice,
};
